import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ProfileService } from "../profile/profile.service";
import { UserManagementService } from "./user-management.service";

@Component({
  selector: 'lifedi-modal-add-account',
  templateUrl: './modal-add-account.component.html',
  styleUrls: ['./user-management.component.scss']

})
export class ModalAddAccountComponent {
  modalData: any;
  experties;
  date: Date;
  confirmModalDialog;
  textError: string = null;
  accountForm: FormGroup = null;
  isEdit: boolean = false;
  btnHistoryStyle: string = "width: 110px; border: 2px solid #060E9F"

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddAccountComponent>,
    private profileService: ProfileService,
    private fb: FormBuilder,
    private userManagementService: UserManagementService,
  ) {
    this.getExpertie();
    this.modalData = data;

    if (data.role === 'admin') {
      this.accountForm = this.fb.group({
        username: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      })
    } else if (data.role === 'teacher' || data.role === 'psychologist') {
      this.accountForm = this.fb.group({
        username: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
        experties: ['']
      })
    }

  }

  getSelectedItem(e, accountForm) {
    // // console.log(e.listOfValue.length);
    if (e.listOfValue.length > 0) {
      accountForm.controls['experties'].setValue(JSON.stringify(e.listOfValue));
    } else {
      accountForm.controls['experties'].setValue('');
    }
  }

  getExpertie() {
    this.profileService.getExpertie().subscribe(e => {
      let exp: any = e
      this.experties = exp.result;
      // console.log(this.experties);
    })
  }

  actionFunction() {
    // // console.log(this.accountForm.value);
    const response = {
      status: true,
      value: this.accountForm.value
    }
    let createSubscribe;

    if (this.modalData.role) {
      if (this.modalData.role === 'admin') {
        // console.log('admin');
        createSubscribe = this.userManagementService.createAccountAdmin(this.accountForm.value);
      } else if (this.modalData.role === 'teacher') {
        // console.log('teacher');
        createSubscribe = this.userManagementService.createAccountTeacher(this.accountForm.value)
      } else if (this.modalData.role === 'psychologist') {
        // console.log('psychologist');
        createSubscribe = this.userManagementService.createAccountPsychologistn(this.accountForm.value);
      }
    }
    createSubscribe.subscribe(res => {
      this.textError = null;
      // // console.log(res);
      return this.dialogRef.close(true);
    }, err => {
      // // console.log(err);
      this.textError = err.error.message
    });
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.EXPERTIE_ID === i2.EXPERTIE_ID : i1 === i2;
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }
}
